// extracted by mini-css-extract-plugin
export default {"wrap":"index-module_wrap_naqHu","tabs":"index-module_tabs_F1i5B","current":"index-module_current_MsMjD","content":"index-module_content_nasEH"};